import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import { Card } from '@wds/card';
import { Typography } from '@wds/typography';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  wrapper: {
    backgroundColor: theme.bgColor.bg,
    padding: theme.spacing[5],
  },
}));

const StoryWrapper = ({ title, subTitle, description, children, ...props }) => {
  const classNames = useStyles();
  return (
    <Box display="flex" flexJustify="center" py={4}>
      <div style={{ width: '80%' }}>
        <If condition={title}>
          <Typography component="h1" variant="pageTitle" my={3}>
            {title}
          </Typography>
        </If>
        <If condition={subTitle}>
          <Typography component="h3" variant="cardTitle" my={3}>
            {subTitle}
          </Typography>
        </If>
        <If condition={description}>
          <Typography variant="body" my={3} style={{ width: 400 }}>
            {description}
          </Typography>
        </If>
        <div className={classNames.wrapper}>
          <If condition={children}>
            <Card {...props}>{children}</Card>
          </If>
        </div>
      </div>
    </Box>
  );
};

StoryWrapper.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  padding: PropTypes.bool,
  children: PropTypes.node,
};

StoryWrapper.defaultProps = {
  title: '',
  subTitle: '',
  description: '',
  padding: true,
  children: '',
};

export default StoryWrapper;
